/**
 * Central names used by app-side showcase attachments.
 * Keep these in one place so label changes do not require touching every sample.
 */
export const SHOWCASE_LIBRARY_NAMES = {
  BASE: "Base Library",
  APP: "Template Component Library",
} as const;
